<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.collections_deliveries' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

    <div *ngIf="loading && !this.collection">
        <p-progressSpinner [style]="{'margin-left': '8px', width: '30px', height: '30px' }" strokeWidth="2"
            fill="transparent" animationDuration=".5s">
        </p-progressSpinner>
    </div>

    <div *ngIf="!(loading && !this.collection)">
        <div class="row">
            <div class="col-6">
                <hub-checkbox [label]="'bikeshop.modal.update_job_card.collections.collection' | translate"
                    [(ngModel)]="jobcard.collectionsDeliveries.allowCollection" [disabled]="jobcard.statusID >= 40"
                    (ngModelChange)="jobcard.collectionsDeliveries.allowDelivery = jobcard.collectionsDeliveries.allowCollection">
                </hub-checkbox>
            </div>
            <div class="col-6" *ngIf="jobcard.id && jobcard.collectionsDeliveries.allowCollection">
                <hub-checkbox [label]="'bikeshop.modal.update_job_card.collections.collected' | translate"
                    [(ngModel)]="jobcard.collectionsDeliveries.collected"
                    [disabled]="jobcard.collectionsDeliveries.collected && (jobcard.collectionsDeliveries.delivered || jobcard.statusID >= 40)"></hub-checkbox>
            </div>


        </div>

        <div *ngIf="jobcard.collectionsDeliveries.allowCollection">
            <div class="row margin-top-8">
                <div class="col-md-12">
                    <hub-autocomplete [autofocus]="true"
                        [labelColor]="!collection.fullAddress?.address ? '#f24646' : ''"
                        [label]="'bikeshop.modal.update_job_card.collections.collection_address' | translate"
                        [(ngModel)]="collection.fullAddress" (completeMethod)="searchAddress($event)"
                        (onSelect)="onSelectAddress($event,'COLLECTION')" [suggestions]="addressOptions"
                        [isDisabled]="jobcard.collectionsDeliveries.collected && (jobcard.collectionsDeliveries.delivered || jobcard.statusID >= 40)"
                        [loading]="collectionAddrssLoading" field="address">
                    </hub-autocomplete>
                </div>
            </div>
            <div class="row margin-top-8" *ngIf="!collectionAddrssLoading && collection.addressOutOfRange">
                <div class="col-md-12 label red">{{'bikeshop.modal.shedule_service.collections_address_out_of_range' |
                    translate}}
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-7">
                    <hub-datepicker #datepicker
                        label="{{'bikeshop.modal.update_job_card.collections.collection_date' | translate}}"
                        [labelColor]="!collection.scheduleDate ? '#f24646' : ''"
                        dateFormat="{{countryData.DatePickerFormat}}" [minDate]="minDate" [maxDate]="maxDate"
                        [(ngModel)]="collection.scheduleDate" [disabledDates]="unavailableCollectionDates"
                        [disabled]="!collection.areaID || (jobcard.collectionsDeliveries.collected && (jobcard.collectionsDeliveries.delivered || jobcard.statusID >= 40))"
                        (onDateChanged)="setBookingDate(true)" (onMonthChange)="monthChanged($event)"
                        [showOtherMonths]="false"></hub-datepicker>
                </div>
                <div class="col-md-5">
                    <hub-dropdown #timeslotDropdown
                        label="{{'bikeshop.modal.update_job_card.collections.collection_time_slot' | translate}}"
                        [labelColor]="!collection.timeSlot ? '#f24646' : ''" [options]="collectionTimeSlots"
                        (selectionChange)="selectTimeSlot($event)"
                        [disabled]="!collection.areaID || collection.scheduleDate === null || collectionTimeSlots.length === 0 || (jobcard.collectionsDeliveries.collected && (jobcard.collectionsDeliveries.delivered || jobcard.statusID >= 40))"
                        [ngModel]="collection.timeSlot" optionLabel="label"
                        placeholder="{{ 'bikeshop.modal.update_job_card.collections.collection_time_slot' | translate}}">
                    </hub-dropdown>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-12">
                    <hub-input [label]="'bikeshop.modal.update_job_card.collections.customer_notes' | translate"
                        [(ngModel)]="collection.notes"
                        [isDisabled]="jobcard.collectionsDeliveries.collected && (jobcard.collectionsDeliveries.delivered || jobcard.statusID >= 40)">
                    </hub-input>
                </div>
            </div>

        </div>

        <div class="row margin-top-16">
            <div class="col-6">
                <hub-checkbox [label]="'bikeshop.modal.update_job_card.collections.delivery' | translate"
                    [(ngModel)]="jobcard.collectionsDeliveries.allowDelivery"
                    [disabled]="jobcard.statusID === 50"></hub-checkbox>
            </div>
            <div class="col-6" *ngIf="jobcard.collectionsDeliveries.allowDelivery && jobcard.statusID > 40">
                <hub-checkbox [label]="'bikeshop.modal.update_job_card.collections.delivered' | translate"
                    [(ngModel)]="jobcard.collectionsDeliveries.delivered"
                    [disabled]="jobcard.statusID < 40 && delivery.statusID !== 20"></hub-checkbox>
            </div>
        </div>

        <div *ngIf="(jobcard.collectionsDeliveries.allowDelivery && jobcard.statusID > 40) || (jobcard.collectionsDeliveries.allowDelivery && !jobcard.collectionsDeliveries.allowCollection)">
            <div class="row margin-top-8">
                <div class="col-md-12">
                    <hub-autocomplete [autofocus]="true"
                        [labelColor]="!delivery.fullAddress?.address ? '#f24646' : ''"
                        [label]="'bikeshop.modal.update_job_card.collections.delivery_address' | translate"
                        [(ngModel)]="delivery.fullAddress" (completeMethod)="searchAddress($event)"
                        (onSelect)="onSelectAddress($event,'DELIVERY')" [suggestions]="addressOptions"
                        [isDisabled]="jobcard.collectionsDeliveries.delivered"
                        [loading]="deliveryAddrssLoading" field="address">
                    </hub-autocomplete>
                </div>
            </div>
            <div class="row margin-top-8" *ngIf="!deliveryAddrssLoading && delivery.addressOutOfRange">
                <div class="col-md-12 label red">{{'bikeshop.modal.shedule_service.collections_address_out_of_range' |
                    translate}}
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-7">
                    <hub-datepicker 
                        label="{{'bikeshop.modal.update_job_card.collections.delivery_date' | translate}}"
                        [labelColor]="!delivery.scheduleDate ? '#f24646' : ''"
                        dateFormat="{{countryData.DatePickerFormat}}" [minDate]="minDate" [maxDate]="maxDate"
                        [(ngModel)]="delivery.scheduleDate" [disabledDates]="unavailableDeliveryDates"
                        [disabled]="!delivery.areaID || jobcard.collectionsDeliveries.delivered"
                        (onDateChanged)="setBookingDate(true,'DELIVERY')" (onMonthChange)="monthChanged($event, 'DELIVERY')"
                        [showOtherMonths]="false"></hub-datepicker>
                </div>
                <div class="col-md-5">
                    <hub-dropdown
                        label="{{'bikeshop.modal.update_job_card.collections.delivery_time_slot' | translate}}"
                        [labelColor]="!delivery.timeSlot ? '#f24646' : ''" [options]="deliveryTimeSlots"
                        (onChange)="selectTimeSlot($event, 'DELIVERY')"
                        [disabled]="!delivery.areaID || delivery.scheduleDate === null || deliveryTimeSlots.length === 0 || jobcard.collectionsDeliveries.delivered"
                        [ngModel]="delivery.timeSlot" optionLabel="label"
                        placeholder="{{ 'bikeshop.modal.update_job_card.collections.delivery_time_slot' | translate}}">
                    </hub-dropdown>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-12">
                    <hub-input [label]="'bikeshop.modal.update_job_card.collections.customer_notes' | translate"
                        [(ngModel)]="delivery.notes"
                        [isDisabled]="jobcard.collectionsDeliveries.delivered">
                    </hub-input>
                </div>
            </div>

        </div>

    </div>

</div>


<div class="modal-footer-container" *ngIf="!(loading && !this.collection)">
    <div *ngIf="!isvalid()" class="error-message">
        {{'general.complete_mandatory_fields' | translate }}
    </div>
    <div class="button-container">
        <hub-button *ngIf="!jobcard.id" [text]="'onboarding.button.done' | translate" [disabled]="!isvalid()"
            (buttonClick)="done()" [style]="'secondary'" [size]="'xl'"></hub-button>
        <hub-button *ngIf="jobcard.id" [text]="'bikeshop.modal.update_job_card.collections.save_collection' | translate"
            [disabled]="!isvalid()" (buttonClick)="saveChanges()" [style]="'secondary'" [size]="'xl'"
            [disabled]="busySaving" [loading]="busySaving"></hub-button>
    </div>
    <div class="short-cut-container">
        <!-- <div>
            {{'bikeshop.workshop.jobcard.quote.to_navigate' | translate}}
        </div> -->
        <div>
            <span><daz-icon [name]="'enter'" [size]="'18px'"
                    [color]="'#6B728C'"></daz-icon></span>{{'bikeshop.workshop.jobcard.quote.to_save_and_close'
            |
            translate}}
        </div>
    </div>
</div>